/**
 * Copyright (c) 2018-2019 Mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { MolScriptBuilder as B } from '../../language/builder';
export function getPositionalArgs(args) {
    return Object.keys(args)
        .filter(function (k) { return !isNaN(k); })
        .map(function (k) { return +k; })
        .sort(function (a, b) { return a - b; })
        .map(function (k) { return args[k]; });
}
export function tryGetArg(args, name, defaultValue) {
    return (args && args[name] !== void 0) ? args[name] : defaultValue;
}
export function pickArgs(args) {
    var names = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        names[_i - 1] = arguments[_i];
    }
    var ret = Object.create(null);
    var count = 0;
    for (var _a = 0, _b = Object.keys(args); _a < _b.length; _a++) {
        var k = _b[_a];
        if (names.indexOf(k) >= 0) {
            ret[k] = args[k];
            count++;
        }
    }
    return count ? ret : void 0;
}
export function aggregate(property, fn, initial) {
    return B.struct.atomSet.reduce({
        initial: initial !== void 0 ? initial : property,
        value: fn([B.struct.slot.elementSetReduce(), property])
    });
}
//# sourceMappingURL=script-macro.js.map